import React from 'react';

import type { UserShape } from './ownership-models.ts';
import { PageOwnershipByLineWithContributorsDropdown } from './PageOwnershipByLineWithContributorsDropdown/index.ts';

type PageOwnershipBylineContentProps = {
	owner: UserShape | null;
	author: UserShape;
	contributorCountWithoutOwner: number;
	testId?: string;
	analyticsSource: string;
	generatedBy?: string | null;
};

export const BadgeStylePageOwnershipByline = (props: PageOwnershipBylineContentProps) => {
	return <PageOwnershipByLineWithContributorsDropdown {...props} />;
};
